
import React from 'react';
import './PageStyles.css';

function About() {
  return (
    <div className="page">
      <h1>About TestYodha</h1>

      <p style={{ fontWeight: 'bold', fontSize: '18px' }}>
        Your battle for success begins here.
      </p>

      <p>
        TestYodha is not just an app — it's a mission-driven platform designed to uplift every Indian aspirant preparing for school-level exams and high-stakes competitions like <strong>NDA</strong>, <strong>CDS</strong>, and more.
      </p>

      <p>
        Whether you're in Class 6 or aiming for national defence services, TestYodha becomes your digital coaching partner. Our curated content ensures that you're always studying smart — not just hard.
      </p>

      <h2>🚀 What We Offer</h2>
      <ul style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
        <li>✅ Exam-level mock tests with instant scoring</li>
        <li>✅ Study materials crafted by experts</li>
        <li>✅ Topic-wise and full-length PYQs</li>
        <li>✅ Performance tracking and progress analysis</li>
        <li>✅ Course-based test series from Class 6 to UPSC level</li>
      </ul>

      <h2>🎯 Why Choose Us?</h2>
      <p>
        In a world full of distractions, TestYodha brings you clarity.  
        No fake promises. No unnecessary clutter. Just real, impactful preparation tools — built by educators and developers who care about your goals.
      </p>

      <h2>🧭 Our Mission</h2>
      <p>
        To make quality test preparation accessible, affordable, and effective for every student across India — whether from a metro city or a small village.
      </p>

      
    </div>
  );
}

export default About;